'use client';
import {
  HoverCard,
  Group,
  Button,
  UnstyledButton,
  Text,
  SimpleGrid,
  ThemeIcon,
  Anchor,
  Divider,
  Center,
  Box,
  Burger,
  Drawer,
  Collapse,
  ScrollArea,
  rem,
  useMantineTheme,
  Avatar,
  Menu
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import styled from '@emotion/styled';
import {
  IconNotification,
  IconCode,
  IconBook,
  IconChartPie3,
  IconFingerprint,
  IconCoin,
  IconChevronDown,
  IconLogout,
  IconUser,
  IconMail,
  IconCalendarFilled
} from '@tabler/icons-react';
import { useState } from 'react';
import { SignOutButton } from '@clerk/clerk-react';

export default function AvatarMenu() {
  const [userMenuOpened, setUserMenuOpened] = useState(false);

  return (
    <Menu
      width={260}
      position="bottom-end"
      trigger="hover"
      transitionProps={{ transition: 'pop-top-right' }}
      onClose={() => setUserMenuOpened(false)}
      onOpen={() => setUserMenuOpened(true)}
      withinPortal>
      <Menu.Target>
        <UnstyledButton>
          <Avatar radius="xl" />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component="a"
          href="https://stay.hideout.house/account"
          leftSection={
            <IconCalendarFilled style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
          }>
          My Bookings
        </Menu.Item>
        <Menu.Item
          component="a"
          href="https://stay.hideout.house/account/profile"
          leftSection={<IconUser style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}>
          My Info
        </Menu.Item>
        <SignOutButton>
          <Menu.Item
            leftSection={<IconLogout style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}>
            Logout
          </Menu.Item>
        </SignOutButton>
      </Menu.Dropdown>
    </Menu>
  );
}
